export default "__VITE_ASSET__DJwIkW_2__"